/**
 * @generated SignedSource<<8b2f2fdeaee5394276788a6b5943df70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteAndFeedbackHistoryPaywall_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToHistory: boolean;
      readonly historyLimit: number | null;
      readonly restrictedMetrics: any | null;
    };
  };
  readonly user: {
    readonly isGuest: boolean;
  };
  readonly " $fragmentType": "NoteAndFeedbackHistoryPaywall_viewer";
};
export type NoteAndFeedbackHistoryPaywall_viewer$key = {
  readonly " $data"?: NoteAndFeedbackHistoryPaywall_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteAndFeedbackHistoryPaywall_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "feature",
    "value": "history"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteAndFeedbackHistoryPaywall_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "restrictedMetrics",
              "storageKey": null
            },
            {
              "alias": "hasAccessToHistory",
              "args": (v0/*: any*/),
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"history\")"
            },
            {
              "alias": "historyLimit",
              "args": (v0/*: any*/),
              "kind": "ScalarField",
              "name": "usageLimitForFeature",
              "storageKey": "usageLimitForFeature(feature:\"history\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "4666f2e5c01916510ae45bb69810cdec";

export default node;
